import { Link } from "react-router-dom";
import {AiTwotoneHome} from 'react-icons/ai';
import {MdMovie} from 'react-icons/md';
import {MdOutlineTheaters} from 'react-icons/md';
import {GiTheater} from 'react-icons/gi';
import {BiTimeFive} from 'react-icons/bi';
import {BsFillBookmarkPlusFill} from 'react-icons/bs';
import { useDispatch, useSelector } from "react-redux";

const SideBar = ()=>{
    const dispatch = useDispatch();
    const isOpen = useSelector(state=>state.SideBarReducer);
    const handleClose = ()=>{
        dispatch({type:'CLOSE'})
    }

    return <div className={`flex flex-row fixed top-0 right-0 left-0 z-30 min-h-fit min-w-full md:hidden ${(isOpen)?'translate-x-[-150vw]':'translate-x-0'}`}>

        <div className="flex flex-col bg-background dark:bg-background-dark shadow  max-w-fit px-2 text-headline dark:text-headline-dark font-heading py-12 tracking-wider min-h-[100vh] text-center text-sm justify-between">
            <h2 className="text-md tracking-wide">{`<UNIQUE/>`}</h2>
            <Link to='/' className="flex flex-col items-center"><AiTwotoneHome className="text-4xl"/>Home</Link>
            <Link to='/Movies' className="flex flex-col items-center"><MdMovie className="text-4xl"/>Movies</Link>
            <Link to='/Tvshows' className="flex flex-col items-center"><MdOutlineTheaters className="text-4xl"/>Tv Shows</Link>
            <Link to='/Intheaters' className="flex flex-col items-center"><GiTheater className="text-4xl"/>In Theaters</Link>
            <Link to='/Comingsoon' className="flex flex-col items-center"><BiTimeFive className="text-4xl"/>Coming Soon</Link>
            <Link to='/Watchlist' className="flex flex-col items-center"><BsFillBookmarkPlusFill className="text-4xl"/>Watchlist</Link>
        </div>
        <div className="min-w-full min-h-full border-2 opacity-20 bg-gray-50" onClick={handleClose}>

        </div>
    </div>

}

export default SideBar;